import {Component, OnInit} from '@angular/core';
import {JobsDataService} from '../jobs-data.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {NgForm} from '@angular/forms';
import {Options} from 'select2';
import {UserLanguages} from '../../../shared/models/userLanguages.model';
import {UserExperienceModel} from '../../../shared/models/userExperience.model';
import {UserAbilitiesModel} from '../../../shared/models/userAbilities.model';
import {SelectFieldsTable} from '../create-job/select-fields.table';
import {Select2OptionData} from 'ng-select2';
import {UploadService} from '../../../shared/upload.service';
import {CompanyDataService} from '../../../components/pages/company-account/company-data.service';
import {SelectLocationTable} from '../../../../shared/location-select.table';
import {DropdownDataTable} from '../../../../crm/shared/dropdown-data.table';

import {AngularEditorConfig} from "@kolkov/angular-editor";



@Component({
    selector: 'app-edit-job',
    templateUrl: 'edit-job.component.html',
    styleUrls: ['edit-job.component.scss'],
    providers: [SelectFieldsTable, SelectLocationTable, DropdownDataTable]
})

export class EditJobComponent implements OnInit {

    constructor(private jobsDataService: JobsDataService, private route: ActivatedRoute, private selectFields: SelectFieldsTable,
                private uploadPhoto: UploadService, private companyData: CompanyDataService, private locationSelect: SelectLocationTable,
                private router: Router, private dropdownData: DropdownDataTable) {

        // Initialize the template-form component.
        this.form = {
            userLanguages: [],
            userExperience: [],
            jobAbilities: []
        };

        this.addUserLanguages();
        this.addUserExperience();
        this.addJobAbilities();


    }

    formResponse: boolean;
    formSent: boolean;

    jobAllData: any = [];
    jobId: string;
    isLoaded = false;


    // Select 2 Inputs Options
    public multiOptions: Options;
    public singleOption: Options;

    // Select Fields Input from Table
    languages: Array<string> = [];
    years: Array<number>;
    locations = this.locationSelect.Countries;
    selectOtherBenefits: Array<string>;
    selectCareerPossibility: Array<Select2OptionData>;
    driveLicense: Array<Select2OptionData>;
    selectJobAbilities: Array<Select2OptionData>;
    selectContractType: Array<string>;
    selectExperienceLevel: Array<string>;
    selectWorkProgram: ({ valueName: string; name: string } | string)[];
    selectStudies: ({ valueName: string; name: string } | string)[];
    selectBonus: ({ valueName: string; name: string } | string)[];
    selectWorkSpace: ({ valueName: string; name: string } | string)[];
    selectWeightLiftingRequired: ({ valueName: string; name: string } | string)[];
    selectWorkTemperature: ({ valueName: string; name: string } | string)[];

    // Domenii, Subdomenii & Categorii
    selectedDomain = '';
    Domains: any = this.dropdownData.domains;
    departments = this.dropdownData.departments;
    jobType: any = [];
    subdomains: any;
    subDomainsArray: any = [];
    categories: any = [];
    categoriesArray: any = [];
    selectedSubdomains: string;
    selected: any;
    finalCategories: any = [];
    selectedCategories: any;


    // Server Response After Send
    serverResp = false;
    formHasBeenSend = false;
    formSuccessfulSend = false;
    serverErrorMessages = [];

    // Declare the form model
    public form: {
        userLanguages: UserLanguages[];
        userExperience: UserExperienceModel[];
        jobAbilities: UserAbilitiesModel[];
    };

    // Form Repeaters DTO
    jobDTO: any = [];

    domains = this.selectFields.domains;
    domainsArrayValues: Array<any>;
    // subdomains: Array<any> = [];

    locationsArrayValues: Array<any>;
    city: Array<any> = [];

    selectCategory: Array<Select2OptionData>;

    // Upload File
    selectedFiles?: FileList;
    jobPhoto: string;
    jobPath: string;

    currentCompanyId: string;

    minSal: number = 0;
    maxSal: number = 0;


    selectFile(event: any): void {
        this.selectedFiles = event.target.files;
    }

    htmlContent: any;
    editorConfig: AngularEditorConfig = {
        editable: true,
        height: 'auto',
        minHeight: '200px',
        maxHeight: 'auto',
        width: 'auto',
        minWidth: '0',
        enableToolbar: true,
        showToolbar: true,
        placeholder: 'Enter text here...',
        defaultParagraphSeparator: 'p',
        defaultFontName: '',
        defaultFontSize: '',
        fonts: [
            {class: 'arial', name: 'Arial'},
            {class: 'times-new-roman', name: 'Times New Roman'},
        ],
        sanitize: true,
        toolbarPosition: 'top',
        toolbarHiddenButtons: [
            ['insertImage'],
            ['fontSize'],
            ['insertVideo'],
            ['subscript'],
            ['superscript'],
            ['textColor'],
            ['backgroundColor']
        ]
    };

    ngOnInit() {
        this.jobType=this.dropdownData.jobType;
        this.languages = this.selectFields.languages;
        this.years = this.selectFields.years;
        this.selectOtherBenefits = this.selectFields.selectOtherBenefits;
        this.selectCareerPossibility = this.selectFields.selectCareerPossibility;
        this.driveLicense = this.selectFields.driveLicense;
        this.selectContractType = this.selectFields.selectContractType;
        this.selectExperienceLevel = this.selectFields.selectExperienceLevel;
        this.selectWorkProgram = this.selectFields.selectWorkProgram;
        this.selectStudies = this.selectFields.selectStudies;
        this.selectBonus = this.selectFields.selectBonus;
        this.selectWorkSpace = this.selectFields.selectWorkSpace;
        this.selectCategory = this.selectFields.selectCategory;
        this.selectJobAbilities = this.selectFields.selectJobAbilities;
        this.selectWeightLiftingRequired=this.selectFields.selectWeightLiftingRequired;
        // this.selectUserCommute=this.selectFields.selectUserCommute;
        this.selectWorkTemperature=this.selectFields.selectWorkTemperature;

        // Select 2 Options
        this.multiOptions = {
            width: '100%',
            placeholder: ' -- Selecteaza optiune -- ',
            multiple: true,
            allowClear: true
        };

        this.singleOption = {
            width: '100%',
            placeholder: ' -- Selecteaza optiune -- ',
            allowClear: true
        };


        // Location Loop
        const locationArray = [];
        this.locations.forEach((value) => {
            const country = value.name
            locationArray.push(country);
        });
        this.locationsArrayValues = locationArray;


        this.companyData.getCurrentUserCompany().subscribe((companyResp: object) => {
            // @ts-ignore
            this.currentCompanyId = companyResp.id;
        })


        // Get ID parameter from the selected Job
        this.route.params.subscribe((params: Params) => {
            this.jobId = params.id;

            // Get Data From Specific Job By ID
            this.jobsDataService.getCurrentJob(this.jobId).subscribe(jobData => {
                this.jobAllData = jobData;
                console.log("job data",  this.jobAllData);
                this.isLoaded = true;
                this.jobPhoto = this.jobAllData.photoName;
                this.jobPath = this.jobAllData.photoPath;
                this.htmlContent=this.jobAllData.jobDescription;

                this.minSal = this.jobAllData.minimumSalary;
                this.maxSal = this.jobAllData.maximumSalary;

                this.city = this.locations.find((loc: any) => loc.name === this.jobAllData.country).cities;


                if (this.jobAllData.activitySector !== null) {
                    this.selectedDomain = this.jobAllData.activitySector;
                        this.subdomains = this.Domains.find((dmn: any) => dmn.name === this.selectedDomain).subdomains;
                        this.subdomains.forEach(subdomain => {
                            this.subDomainsArray.push(subdomain.name);
                        })

                    if (this.jobAllData.activitySubSector !== null) {
                        this.selectedSubdomains = this.jobAllData.activitySubSector;

                        this.categories = this.Domains
                            .find((dmn: any) => dmn.name === this.selectedDomain).subdomains
                            .find((subDm: any) => subDm.name === this.selectedSubdomains).categories;
                        this.categoriesArray = this.categories;

                        if (this.jobAllData.category !== null) {
                            this.selectedCategories = this.jobAllData.category;
                        }
                    }
                }

                if (this.jobAllData.foreignLanguage != null) {
                    this.form.userLanguages = this.jobAllData.foreignLanguage;
                }

                if (this.jobAllData.similarExperience != null) {
                    this.form.userExperience = this.jobAllData.similarExperience;
                }

                if (this.jobAllData.jobAbilities != null) {
                    this.form.jobAbilities = this.jobAllData.jobAbilities;
                }


            }, error => {
            })
        })

    }

    changeDomain(domain: any) {
        this.subDomainsArray = [];
        setTimeout(() => {
            this.selectedSubdomains = null;
        })
        this.subdomains = this.Domains.find((dmn: any) => dmn.name === domain.target.value).subdomains;
        this.subdomains.forEach(subdomain => {
            this.subDomainsArray.push(subdomain.name);
        })
    }

    changeSubDomain(subdomain: any) {
        this.categoriesArray = [];
        setTimeout(() => {
            this.selectedCategories = null;
            this.selected = subdomain;
            console.log(this.selected);
            if (this.selected) {
                this.categories = this.subdomains
                    .find((subDm: any) => subDm.name === this.selected).categories;
                this.categoriesArray = this.categories;
            }
        })
    }

    changeCountry(country: any) {
        this.city = this.locations.find((loc: any) => loc.name === country).cities;
    }

    // Update Job
    onUpdateJob(jobForm: NgForm) {

        this.jobDTO = {
            languages: jobForm.value.foreignLanguage,
            similarExperience: jobForm.value.similarExperience,
            jobAbilities: jobForm.value.jobAbilities,
        }

        // Job Language Repeater
        const jobLanguageValue = [];
        for (const key of Object.keys(this.jobDTO.languages)) {
            const language = this.jobDTO.languages[key];
            jobLanguageValue.push(language);
        }

        // Job Experience Repeater
        const jobSimilarExperienceValue = [];
        for (const key of Object.keys(this.jobDTO.similarExperience)) {
            const simExperience = this.jobDTO.similarExperience[key];
            jobSimilarExperienceValue.push(simExperience);
        }

        // Job Abilities Repeater
        const jobAbilitiesValue = [];
        for (const key of Object.keys(this.jobDTO.jobAbilities)) {
            const jobAbil = this.jobDTO.jobAbilities[key];
            jobAbilitiesValue.push(jobAbil);
        }


        // Store Job Input
        this.jobAllData = {


            jobPostingDate: this.jobAllData.jobPostingDate,
            companyId: this.currentCompanyId,

            // Job Details Section
            jobTitle: jobForm.value.jobTitle !== '' ? jobForm.value.jobTitle : null,
            idealCandidate: jobForm.value.idealCandidate,
            jobDescription: jobForm.value.jobDescription !== '' ? jobForm.value.jobDescription : null,
            jobEndingDate: this.jobAllData.jobEndingDate,
            photoName: this.jobPhoto,
            photoPath: this.jobPath,
            videoLink: jobForm.value.videoLink,
            benefits: jobForm.value.benefits,
            country: jobForm.value.country !== '' ? jobForm.value.country : null,
            city: jobForm.value.city !== '' ? jobForm.value.city : null,
            openPositions: jobForm.value.openPositions !== '' ? jobForm.value.openPositions : 0,
            relocationPossibility: jobForm.value.relocationPossibility,
            relocationPackageIncluded: jobForm.value.relocationPackageIncluded,
            workType: jobForm.value.workType !== '' ? jobForm.value.workType : null,
            contractType: jobForm.value.contractType !== '' ? jobForm.value.contractType : null,
            experienceLevel: jobForm.value.experienceLevel !== '' ? jobForm.value.experienceLevel : undefined,
            jobDisponibility: jobForm.value.jobDisponibility !== '' ? jobForm.value.jobDisponibility : undefined,
            activitySector: jobForm.value.activitySector !== '' ? jobForm.value.activitySector : undefined,
            activitySubSector: jobForm.value.activitySubSector !== '' ? jobForm.value.activitySubSector : undefined,
            department: jobForm.value.department !== '' ? jobForm.value.department : undefined,
            category: jobForm.value.category !== '' ? jobForm.value.category : undefined,
            mandatoryCategories: [
                'ADFG', 'Testuts'
            ],
            departmentCoordinator: jobForm.value.departmentCoordinator,

            // Studies Requirements Section
            studies: jobForm.value.studies === '' ? undefined : jobForm.value.studies,
            otherCourses: jobForm.value.otherCourses,

            // Required Skills Section
            foreignLanguage: jobLanguageValue,
            pcKnowledge: jobForm.value.pcKnowledge,
            driverLicense: jobForm.value.driverLicense !== '' ? jobForm.value.driverLicense : undefined,
            availableForTraveling: jobForm.value.availableForTraveling,
            jobAbilities: jobAbilitiesValue,

            // Work Experience Section
            similarExperience: jobSimilarExperienceValue,
            totalExperience: jobForm.value.totalExperience !== '' ? jobForm.value.totalExperience : 0,
            legalWorkPermitMandatory: jobForm.value.legalWorkPermitMandatory,

            // Salary Section
            confidentialSalaryLevel: jobForm.value.confidentialSalaryLevel,
            minimumSalary: jobForm.value.minimumSalaryLevel !== '' ? jobForm.value.minimumSalaryLevel : 0,
            maximumSalary: jobForm.value.maximumSalaryLevel !== '' ? jobForm.value.maximumSalaryLevel : 0,
            bonus: jobForm.value.bonus !== '' ? jobForm.value.bonus : undefined,
            averageBonusValue: jobForm.value.averageBonusValue !== '' ? jobForm.value.averageBonusValue : 0,
            otherBenefits: jobForm.value.otherBenefits !== '' ? jobForm.value.otherBenefits : undefined,
            careerPossibility: jobForm.value.careerPossibility !== '' ? jobForm.value.careerPossibility : undefined,


            // Work Environment Section
            weightLiftingRequired: jobForm.value.weightLiftingRequired !== '' ? jobForm.value.weightLiftingRequired : undefined,
            workTemperature: jobForm.value.workTemperature !== '' ? jobForm.value.workTemperature : undefined,

            workProgram: jobForm.value.workProgram !== '' ? jobForm.value.workProgram : undefined,
            workSpace: jobForm.value.workSpace !== '' ? jobForm.value.workSpace : undefined,
            // physicalEffort: {
            //     type: jobForm.value.physicalType,
            //     details: jobForm.value.physicalDetails,
            // },
            physicalEffortRequired: {
                type: jobForm.value.physicalEffortRequiredType,
                detail: jobForm.value.physicalDetails
            },
            // Mini Interview Section
            miniInterview: this.jobAllData.miniInterview,
            candidateMatch: this.jobAllData.candidateMatch,
            mandatoryFields: this.jobAllData.mandatoryFields,
            status: this.jobAllData.status,
            finished: this.jobAllData.finished
        }

        if (jobForm.valid && (this.minSal <= this.maxSal)) {
            // Subscribe and Use Update Job
            console.log("here?")
            this.jobsDataService.updateJobData(this.jobAllData, this.jobId).subscribe(data => {
                // Upload Service for Upload File
                this.uploadPhoto.upload(this.selectedFiles, '/uploadJobImage?jobId=' + this.jobId);

                this.formResponse = true;
                this.formSent = true;

                // Scroll Top
                window.scrollTo({top: 0, behavior: 'smooth'});

                // After 5sec Redirect User To A Specific Page
                setTimeout(() => {
                    // Redirect To Your Created Job
                    this.router.navigate(['/job/' + this.jobId]);
                }, 5000)

            }, error => {
                console.log( this.jobAllData, this.jobId , 'JobDUpData')
                this.formResponse = false;
                this.formSent = true;

                window.scrollTo({top: 0, behavior: 'smooth'});
            });
        } else {
            console.log('form invalid', jobForm)
            this.formResponse = false;
            this.formSent = true;
            window.scrollTo({top: 0, behavior: 'smooth'});
        }


    }

    // Add The First Set of Inputs For Languages
    addUserLanguages() {
        this.form.userLanguages.push({
            id: Date.now(),
            language: '',
            level: ''
        });
    }

    // Add The First Set of Inputs For Experience
    addUserExperience() {
        this.form.userExperience.push({
            id: Date.now(),
            department: '',
            year: null
        })
    }

    // Add The First Set of Inputs For Abilities
    addJobAbilities() {
        this.form.jobAbilities.push({
            id: Date.now(),
            abilityName: '',
            abilityDescription: '',
            abilityLevel: ''
        })
    }

    // On Click Remove The Selected Inputs For Languages
    removeUserLanguages(index: number) {
        this.form.userLanguages.splice(index, 1);
    }

    // On Click Remove The Selected Inputs For Experience
    removeUserExperience(index: number) {
        this.form.userExperience.splice(index, 1);
    }

    // On Click Remove The Selected Inputs For Abilities
    removeJobAbilities(index: number) {
        this.form.jobAbilities.splice(index, 1)
    }

}
